<template id="map-template">
  <div class="homeview-realtime-data">
    <!-- 客流信息 -->
    <div class="circle-chart flex1">
      <div class="passeng-item item1">
        <div class="passeng-icon-wrapper">
          <span class="font1">{{ sumInCountNum }}</span>
          <span class="font2">今日客流</span>
          <div class="passeng-icon"></div>
        </div>
      </div>
      <div class="passeng-item item2">
        <div class="passeng-icon-wrapper">
          <span class="font1">{{ maxCapacity }}</span>
          <span class="font2">最大承载</span>
          <div class="passeng-icon"></div>
        </div>
      </div>
    </div>
    <!-- 客流折线 -->
    <div class="trend-chart2 flex1" style="height: 10rem; margin: 2rem 0">
      <linechart2 :chartData="passengerFlowTrendData"></linechart2>
    </div>
    <!-- 车位显示 -->
    <div class="table-chart flex2">
      <div class="carStatus_display">
        <div class="car_statusOne">
          <img src="../../../theme-default/src/images/car_blue.png" alt="" />
          <p class="name">总车位</p>
          <p class="info colorblue">{{ cheWeiObj.total }}</p>
        </div>
        <!-- <div class="car_statusOne">
          <img src="../../../theme-default/src/images/car_red.png" alt="" />
          <p class="name">剩余车位</p>
          <p class="info colorred">{{ cheWeiObj.yu }}</p>
        </div>
        <div class="car_statusOne">
          <img src="../../../theme-default/src/images/car_yellow.png" alt="" />
          <p class="name">今日累计</p>
          <p class="info coloryellow">{{ cheWeiObj.today }}</p>
        </div>     -->
        <div class="car_statusOne">
          <img src="../../../theme-default/src/images/car_yellow.png" alt="" />
          <p class="name">今日入场</p>
          <p class="info colorred">{{ cheWeiObj.countIn }}</p>
        </div>
        <div class="car_statusOne">
          <img src="../../../theme-default/src/images/car_red.png" alt="" />
          <p class="name">今日出场</p>
          <p class="info coloryellow">{{ cheWeiObj.countOut }}</p>
        </div>
      </div>
      <!-- 车位表格 table-chart-->
      <div class="table_box">
        <el-table
          :data="tableData"
          ref="multipleTable"
          border
          style="width: 100%; margin: 0 auto"
          fixed
        >
          <el-table-column
            prop="name"
            label="停车场"
            min-width="34%"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="totalNum"
            label="总车位"
            min-width="22%"
          ></el-table-column>
          <el-table-column
            prop="useNum"
            label="已使用"
            min-width="22%"
          ></el-table-column>
          <el-table-column prop="" label="负载率" min-width="22%">
            <template slot-scope="scope">
              <span
                style="color: #fe4e4e; font-weight: 500; font-size: 1.1667rem"
                >{{ getRate(scope.row) }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTodayFlow,
  getFlowTrend,
  getTodayCar,
  getTrendByTimes,
  getCarPark,
} from "@/api/src/bigData";
import { getEquipmentCode } from "@/api/src/equipment";
import moment from "moment";

export default {
  name: "HomeViewPassengerFlowCockpit",
  componentName: "HomeViewPassengerFlowCockpit",
  components: {},
  props: {},
  data() {
    return {
      timer: null,
      sumInCountNum: 0, //总的今日客流
      maxCapacity: 0, //获取配置的最大承载量
      passengerFlowTrendData: { days: [], data: [] },
      cheWeiObj: {
        total: 0,
        yu: 0,
        today: 0,
        countIn:0,
        countOut:0,
      },
      tableData: [],
    };
  },
  methods: {
    // 获取今日客流
    getTodayFlowData() {
      getTodayFlow({
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
      }).then((res) => {
        this.sumInCountNum = res.data[0].curDayDayCount;
      });
    },
    //获取最大承载
    getCapacity() {
      getEquipmentCode("MaximumBearingCapacity").then((response) => {
        this.maxCapacity = response.data;
      });
    },
    // 获取今日客流趋势
    getTodayFlowTrendData() {
      let params = {
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        polityType: 3,
        timeType: "hour",
        timeValue: 24,
        startTime: moment().format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
      };
      getFlowTrend(params).then((res) => {
        let year = new Date().getFullYear();
        let arr = res.data.dataList[year];
        this.passengerFlowTrendData.days = arr.map((item) =>
          moment(item.dataTime).format("HH时")
        );
        this.passengerFlowTrendData.data = arr.map((item) => item.count);
      });
    },
    // 获取今日车流
    // getTodayCarData() {
    //   getTodayCar({
    //     district: this.CNF("app.districtCode"),
    //     districtCode: this.CNF("app.districtCode"),
    //   }).then((res) => {
    //     this.cheWeiObj.today = res.data[0].curDayDayCountIn;
    //   });
    // },
    getTrendByTimes(){
      getTrendByTimes('staCarAnalysis',{
        district: this.CNF("app.districtCode"),
        districtCode: this.CNF("app.districtCode"),
        startTime:moment().format("YYYY-MM-DD"),
        endTime:moment().format("YYYY-MM-DD"),
        polityType: 3,
        timeType: "hour",
        timeValue: "24"}).then(res =>{
          let countIn = 0, countOut = 0;
          res.data.forEach((el) => {
            countIn += el.countIn;
            countOut += el.countOut;
          });
          this.cheWeiObj.countIn = countIn;
          this.cheWeiObj.countOut = countOut;
        })
    },
    // 获取停车场表格，计算总车位、剩余车位
    getCarParkTable() {
      getCarPark({}).then((res) => {
        this.tableData = res.data;
        let totalSum = 0,
          useSum = 0;
        res.data.forEach((el) => {
          totalSum += el.totalNum;
          useSum += el.useNum;
        });
        this.cheWeiObj.total = totalSum;
        this.cheWeiObj.yu = totalSum - useSum;
      });
    },
    // 计算负载率
    getRate(row) {
      if (row.useNum == "0") {
        return "0%";
      } else {
        let result = row.useNum / row.totalNum;
        return (result * 100).toFixed(2) + "%";
      }
    },
  },
  created() {
    this.getCapacity();
    this.getTodayFlowData();
    this.getTodayFlowTrendData();
    this.getTrendByTimes();
    // this.getTodayCarData();
    this.getCarParkTable();
  },
  mounted() {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getTodayFlowData();
      this.getTodayFlowTrendData();
      this.getTrendByTimes();
      // this.getTodayCarData();
      this.getCarParkTable();
    }, window.$config.app.intervalTime || 300000);
  },
  beforeDestroy() {},
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>